var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPopOut = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.5449 3.39999c-.413 0-.7478.33677-.7478.75219 0 .41541.3348.75218.7478.75218h3.2653l-6.01743 6.05254c-.29204.2938-.29204.77 0 1.0638.29204.2937.76552.2937 1.05756 0l6.01737-6.0526v3.28436c0 .41542.3348.75214.7479.75214.413 0 .7478-.33672.7478-.75214v-5.10028c0-.41542-.3348-.75219-.7478-.75219zm-5.23212 1.93491c-1.0564 0-1.91279.85639-1.91279 1.91279v7.19141c0 1.0564.85639 1.9128 1.91279 1.9128h7.13612c1.0564 0 1.9128-.8564 1.9128-1.9128v-2.3372c0-.4142-.3358-.75-.75-.75s-.75.3358-.75.75v2.3372c0 .228-.1848.4128-.4128.4128h-7.13612c-.22797 0-.41279-.1848-.41279-.4128v-7.19141c0-.22797.18482-.41279.41279-.41279h2.94955c.41422 0 .74997-.33578.74997-.75 0-.41421-.33575-.75-.74997-.75z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPopOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pop-out.457882b139ec4ef8c498d5c33da77a20.svg";